

import './Header.css';
import logoImg from '../assets/images/1024.png';
import React, { useState } from 'react';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const handleToggle = () => setMenuOpen((open) => !open);
  const handleLinkClick = () => setMenuOpen(false);
  return (
    <header>
      <nav>
        <div className="logo">
          <img src={logoImg} alt="Seder Travel Logo" />
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <h1 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
              Seder Travel & Tourism
              <span style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.5 24.5L25.5 14L2.5 3.5L2.5 11.5L20 14L2.5 16.5L2.5 24.5Z" fill="#4e54c8"/>
                </svg>
              </span>
            </h1>
          </div>
        </div>
        <ul className={`nav-links${menuOpen ? ' show' : ''}`}>
          <li><a href="#home" onClick={handleLinkClick}>Home</a></li>
          <li><a href="#services" onClick={handleLinkClick}>Our Services</a></li>
          <li><a href="#destinations" onClick={handleLinkClick}>Destinations</a></li>
          <li><a href="#about" onClick={handleLinkClick}>About</a></li>
          <li><a href="#contact" onClick={handleLinkClick}>Contact</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
